// extracted by mini-css-extract-plugin
module.exports = {"body":"DetailPanel_body__3k6Po","container":"DetailPanel_container__3njss","header":"DetailPanel_header__2x_JT","title":"DetailPanel_title__2RUVG"};